export const environment = {
  production: false,
  url: 'https://apiv2-iheal-staging.stacknize.com/auth-sub',
  domain: 'https://api-iheal.stacknize.com',
  baseUrl: "https://images-iheal-staging.stacknize.com",
  firebase: {
    apiKey: 'AIzaSyC2FCyjYccFiHQDcR37AlZyRDgHY7xezNI',
    authDomain: 'lifesaver-4164d.firebaseapp.com',
    projectId: 'lifesaver-4164d',
    storageBucket: 'lifesaver-4164d.firebasestorage.app',
    messagingSenderId: '17302391811',
    appId: '1:17302391811:web:d80c2b4cf82582b73b1236',
    measurementId: 'G-HQ6WKM420R',
    vapidKey: 'BJ_uGSxQqJvjKdX9B2zt9OLWKKurzUqw8Gr_XKLWL7FXCj3tkUZoU8cE8V_ngbYybHTBCJC5Uc1w5AzgBq8pX0g',
  },
  reminderDelay: 5000,
  socketUrl: 'https://apiv2-iheal-staging.stacknize.com',
};
